module.exports = __webpack_public_path__ + "6b707c61/img/ion_calendar-number.3ac5bd07.svg";